import {Injectable} from '@angular/core';
import {SpatialUtilService} from '../spatial-util.service';
import {AlertModalService} from '../../../common/component/modal';
import {catchError, of, tap} from "rxjs";

/* eslint-disable @typescript-eslint/no-explicit-any */
@Injectable({
    providedIn: 'root'
})
export class PolygonService {
    title = 'PolygonService';

    constructor(
        private alertModalService: AlertModalService,
        private spatialUtilService: SpatialUtilService
    ) {}

    removeBusinessFeatureIdsFromPolygon(polygon: any, businessFeatureType: string) {
        console.debug(`${this.title} - removeBusinessFeatureIdsFromPolygon`);

        // special case for interest, as interests can be associated with multiple polygons, so the attribute name is a plural
        const featureAttributeName = businessFeatureType === 'interest' ? 'interestids' : businessFeatureType + 'id';

        // blank interestids on polygon is normally an empty as it denotes an empty array
        polygon.attributes[featureAttributeName] = businessFeatureType === 'interest' ? '' : null;

        this.applyPolygonUpdates([polygon]).subscribe();
    }

    updatePolygonTypesIfRequired(featuresAfterUpdate: any[], featuresBeforeUpdate: any[]) {
        console.debug(`${this.title} : updatePolygonTypesIfRequired by watch`);

        const polygonsToBeUpdated = featuresAfterUpdate.reduce((acc: any[], featureAfterUpdate: any) => {
            const businessType = featureAfterUpdate.attributes.type || featureAfterUpdate.attributes.interesttype;
            if (featuresBeforeUpdate.some(f => f.attributes.id === featureAfterUpdate.attributes.id && f.attributes.type !== businessType)) {
                // Update all linked polygons with same lot type id
                this.spatialUtilService.getPolygonGraphicsByParentFeature(featureAfterUpdate).forEach((polygon: any) => {
                    polygon.attributes = structuredClone(polygon.attributes);
                    polygon.attributes.type = businessType;
                    acc.push(polygon);
                });
            }
            return acc;
        }, []);

        if (polygonsToBeUpdated.length) {
            return this.applyPolygonUpdates(polygonsToBeUpdated);
        }
        return of(null);
    }

    private applyPolygonUpdates(polygons: any[]) {
        const logPrefix = `${this.title} - applyPolygonUpdates`;
        console.debug(logPrefix);

        return this.spatialUtilService.applyEdits('polygon', null, polygons, null).pipe(
            tap(res => {
                console.debug(`${logPrefix} - updates:`, res.updates);

                if (res.updates && res.updates.every(u => u.success || u.error.code === 1011 /*Ignore 1011: Object is missing*/)) {
                    console.debug(`${logPrefix} - polygons updated successfully`);
                } else if (res.updates) {
                    this.alertModalService.createAlertMessage(`Error updating polygons: ${res.updates[0].error?.message || ''}`, 'Ok');
                }
            }),
            catchError(err => this.alertModalService.createAlertMessage(`Error updating polygons: ${err}`, 'Ok'))
        );
    }
}
